module.exports = __webpack_public_path__ + "static/media/11pets_logo_light.47d71dee.png";